//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import UBT from '@/utils/ubt';
import { leaderCulomn } from '@/const/constants';
import {
  getLeaderPerformance,
  getStatis,
} from '@/api/activity';

export default {
  filters: {
    capitalize(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
  data() {
    const fullYear = new Date().getFullYear();
    const m = new Date().getMonth() + 1;
    const fullMonth = m < 10 ? `0${m}` : m;
    const queryDate = `${fullYear}-${fullMonth}-01`;
    return {
      arrowStatus: true,
      hasLeft: false,
      hasRight: false,
      scrollValue: 0,
      columns: [],
      cardType: 1,
      statis: {},
      showPopupPicker: false,
      tableData: [],
      fullMonth,
      fullYear,
      pageIndex: 1,
      pageSize: 15,
      queryDate,
      activityId: this.$route.query.activityId,
      roleType: this.$route.query.roleType,
      tableHeight: 0,
    };
  },
  computed: {
    ...mapState({
      promotionUserId: state => state.user.loginResult.promotionUserId || '1',
    }),
    tableStyle() {
      return {
        height: `${this.tableHeight}px`,
      };
    },
  },
  mounted() {
    const { activityId, roleType, sourceId } = this.$route.query;
    if (
      +roleType !== +this.$store.state.user.loginResult.roleType
        || +activityId !== +this.$store.state.user.loginResult.activityId
        || (this.$store.state.user.loginResult.sourceId
         && sourceId !== this.$store.state.user.loginResult.sourceId)
    ) {
      this.$router.replace({
        name: 'login',
        query: this.$route.query
      });
      this.$throw(new Error('登录已失效，请重新登录'));
      return;
    }
    UBT.pageView({
      pageId: 'H5_换电_领队绩效页',
    });

    this.columns = leaderCulomn;
    window.onresize = this.setTableShadow;
    window.onload = this.setTableShadow;

    this.$nextTick(() => {
      setTimeout(() => {
        const dom = document.querySelector('.table-body');
        if (dom) {
          dom.addEventListener('scroll', (e) => {
            const {
              offsetHeight,
              scrollTop,
              scrollHeight
            } = e.srcElement;
            if (scrollHeight - offsetHeight - 10 < scrollTop) {
              this.pageIndex += 1;
              this.loadLeaderPage({ userId: this.promotionUserId });
            }
          });
        }
      }, 1000);
    });
    this.initData();
  },
  methods: {
    initData() {
      this.getStatData({ type: this.roleType });
      this.loadLeaderPage({ userId: this.promotionUserId });
    },
    /**
     * 获取统计数据
     */
    getStatData({ type }) {
      getStatis({
        activityId: this.activityId,
        type,
        queryDate: this.queryDate,
      }).then((data) => {
        this.statis = data;
      });
    },
    /**
     * 加载队长数据
     */
    loadLeaderPage({ userId }) {
      getLeaderPerformance({
        queryDate: this.queryDate,
        activityId: this.activityId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        userId,
      }).then((data) => {
        this.tableData = this.tableData.concat(data.list || []);
      });
    },

    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
    handleBodyScroll() {
      this.scrollValue = this.$refs.tableScroll.scrollLeft;
      this.hasRight = this.scrollValue - this.leftScroll < 0;
      this.hasLeft = this.scrollValue > 0;
      this.$refs.scrollHead1.scrollLeft = this.scrollValue;
    },
    setTableShadow() {
      this.leftScroll = this.$refs.tableContent.clientWidth - this.$refs.tableScroll.clientWidth;
      this.handleBodyScroll();
    },

    onChange() {
      const that = this;
      this.arrowStatus = false;
      this.$vux.datetime.show({
        cancelText: '取消',
        confirmText: '确定',
        format: 'YYYY-MM',
        value: `${this.fullYear}-${this.fullMonth}`,
        onHide() {
          that.arrowStatus = true;
        },
        onConfirm(date) {
          that.arrowStatus = true;
          if (date !== `${that.fullYear}-${that.fullMonth}`) {
            [that.fullYear, that.fullMonth] = date.split('-');
            that.statis = [];
            that.tableData = [];
            that.pageIndex = 1;
            that.queryDate = `${date}-01`;
            that.initData();
          }
        },
      });
    },

    query({ memberUserId, nickName }) {
      UBT.clickButton({
        pageId: 'H5_换电_领队绩效页',
        buttonName: 'H5_换电_领队绩效页_查看记录',
      });
      const { sourceId } = this.$route.query;
      this.$router.push({
        name: 'recordSub',
        query: {
          activityId: this.activityId,
          roleType: this.roleType,
          sourceId,
          month: this.fullMonth,
          year: this.fullYear,
          userId: memberUserId,
          subRoleType: 2,
          nickName
        }
      });
    },
  },
};
